import styles from "../../assets/scss/modules/PublicListingSingle.module.scss";
import React, {Fragment} from 'react';
import {useSingleListing} from "../context/SingleListingProvider.tsx";
import useCtrMetaFields from "../../hooks/useCtrMetaFields.tsx";
import {
    CtrDomainsVf,
    CtrDynamicTables,
    CtrInscriptions,
    CtrUnitesDetaillees
} from "../../graphql/generated/graphql-main.tsx";
import {useFetchDetailedUnitsQuery} from "../../store/api-rest.ts";
import {useWpContext} from "../context/WordPressProvider.tsx";

type Props = {}
const ListingTabBuilding = (props: Props) => {
    const {others, is_fr} = useWpContext<ZListingSingle>();
    const {listing: lst} = useSingleListing();
    const {toLabel, toHtml} = useCtrMetaFields();
    const {data: detailedUnits} = useFetchDetailedUnitsQuery(others.mls_id);

    const elem = toHtml<CtrInscriptions>(lst, CtrDynamicTables.Inscriptions);

    return <Fragment>
        {/* main building-related characteristics from 'INSCRIPTIONS' */}
        <div className={"space-y-4 columns-xs *:break-inside-avoid"}>
            <div>{elem("ANNEE_CONTRUCTION")}</div>
            <div>{elem("APPARTEMENT")}</div>
            <div>{elem("CODE_ANNEE_CONSTRUCTION")}</div>
            <div>{elem("SUPERFICIE_BATIMENT", {
                type: "numeric",
                suffix: lst?.UM_SUPERFICIE_BATIMENT?.toLowerCase()
            })}</div>
            <div>{elem("SUPERFICIE_HABITABLE", {
                type: "numeric",
                suffix: lst?.UM_SUPERFICIE_HABITABLE?.toLowerCase()
            })}</div>
            <div>{elem("FACADE_BATIMENT", {suffix: lst?.UM_DIMENSION_BATIMENT?.toLowerCase()})}</div>
            <div>{elem("PROFONDEUR_BATIMENT", {suffix: lst?.UM_DIMENSION_BATIMENT?.toLowerCase()})}</div>
            {/*<div>{elem("IND_IRREGULIER_BATIMENT")}</div>*/}
            <div>{elem("NB_CHAUFFE_EAU_LOUE")}</div>
            <div>{elem("NB_ETAGES")}</div>
            <div>{elem("NB_PIECES")}</div>
            <div>{elem("NB_CHAMBRES")}</div>
            <div>{elem("NB_CHAMBRES_HORS_SOL")}</div>
            <div>{elem("NB_CHAMBRES_SOUS_SOL")}</div>
            <div>{elem("NB_SALLES_BAINS")}</div>
            <div>{elem("NB_SALLES_EAU")}</div>
            <div>{elem("NB_UNITES_TOTAL")}</div>
            <div>{elem("NIVEAU", {domain: CtrDomainsVf.Niveau})}</div>
            <div>{elem("PARTICULARITE_CONSTRUCTION", {
                domain: CtrDomainsVf.ParticulariteConstruction
            })}</div>
            <div>{elem("TYPE_BATIMENT", {domain: CtrDomainsVf.TypeBatiment})}</div>
            <div>{elem("TYPE_COPROPRIETE", {domain: CtrDomainsVf.TypeCopropriete})}</div>
            <div>{elem("TYPE_SUPERFICIE_HABITABLE", {domain: CtrDomainsVf.TypeSuperficieHabitable})}</div>
        </div>

        {/* show separator when there are detailed units */}
        {/*{detailedUnits?.length && <Divider className={"mt-2 mb-4 bg-crimson"}/>}*/}

        {/* more details per unit */}
        <div className={"columns-xs mt-5"}>
            {detailedUnits?.map((it: CtrUnitesDetaillees, idx) => {
                const elem2 = toHtml<CtrUnitesDetaillees>(it, CtrDynamicTables.UnitesDetaillees);

                return <div key={`dunit-${it?.NO_INSCRIPTION}.${idx}`} className={"break-inside-avoid mb-4"}>
                    <div className={styles.subtitle__eval}>
                        {elem2("SEQ", {uniline: true})}
                    </div>
                    <div>{elem2("NB_STAT_INTERIEURS")}</div>
                    <div>{elem2("NB_STAT_EXTERIEURS")}</div>
                    <div>{elem2("NB_PIECES")}</div>
                    <div>{elem2("NB_CHAMBRES")}</div>

                    {/* note: these are non-essential details to display */}
                    {/*<div>{elem2("TYPE_UNITE_DET", {domain: CtrDomainsVf.TypeUniteDet})}</div>*/}
                    {/*<div>{elem2("SUPERFICIE_TOTALE")}</div>*/}
                    {/*<div>{elem2("UM_SUPERFICIE_TOTALE")}</div>*/}
                    {/*<div>{elem2("IND_VACANT")}</div>*/}
                    {/*<div>{elem2("INCLUS_TAXE_EAU")}</div>*/}
                    {/*<div>{elem2("INCLUS_SEMI_MEUBLE")}</div>*/}
                    {/*<div>{elem2("INCLUS_MEUBLE")}</div>*/}
                    {/*<div>{elem2("INCLUS_PELOUSE")}</div>*/}
                    {/*<div>{elem2("INCLUS_INTERNET")}</div>*/}
                    {/*<div>{elem2("INCLUS_ELECTRICITE")}</div>*/}
                    {/*<div>{elem2("INCLUS_EAU_CHAUDE")}</div>*/}
                    {/*<div>{elem2("INCLUS_DENEIGEMENT")}</div>*/}
                    {/*<div>{elem2("INCLUS_CLIMATISATION")}</div>*/}
                    {/*<div>{elem2("INCLUS_CHAUFFAGE")}</div>*/}
                    {/*<div>{elem2("INCLUS_CABLETELE")}</div>*/}
                    {/*<div>{elem2(is_fr ? "AU_INCLUS_INFO_F" : "AU_INCLUS_INFO_A")}</div>*/}
                </div>
            })}
        </div>
    </Fragment>
};

export default ListingTabBuilding;